import React, { useEffect, useState } from "react";
import { DeleteFilled, EditOutlined } from "@ant-design/icons";
import { Card } from "antd";
import { Image } from "antd";
import "./PatientProfile.css";
import {
  getRole,
  formatDate,
  capitalizeFirstLetter,
} from "../Helpers/Utilities/Common";
import defaultAvatar from "../../Assets/Images/clinica-prime-icon.png";
import { getFileByUrl } from "../Helpers/API/PatientApi/PatientApi";

const PatientCard = ({ patientDetails, onEditClick, onDeleteClick }) => {
  const [imageSrc, setImageSrc] = useState(defaultAvatar);

  useEffect(() => {
    let isMounted = true;
    let toRevoke = null;
    const loadImage = async () => {
      const url = patientDetails?.file_url;
      if (!url) {
        if (isMounted) setImageSrc(defaultAvatar);
        return;
      }
      try {
        const res = await getFileByUrl(url);
        const data = res?.data;
        const candidate =
          data?.objectUrl ||
          (typeof data === "string" && data) ||
          data?.file_url ||
          data?.url ||
          data?.file ||
          data?.data?.file_url ||
          url;
        if (isMounted) {
          setImageSrc(candidate || defaultAvatar);
          if (candidate && candidate.startsWith("blob:")) {
            toRevoke = candidate;
          }
        }
      } catch {
        if (isMounted) setImageSrc(url || defaultAvatar);
      }
    };
    loadImage();
    return () => {
      isMounted = false;
      if (toRevoke) {
        try {
          URL.revokeObjectURL(toRevoke);
        } catch {}
      }
    };
  }, [patientDetails?.file_url]);

  return (
    <Card
      className="patient-card"
      cover={
        <Image
          alt=""
          src={imageSrc}
          fallback={defaultAvatar}
          preview={false}
          style={{
            objectFit: "cover",
          }}
        />
      }
      actions={
        getRole() === "director" || getRole() === "pcp" || getRole() === "specialist"
          ? [
              <EditOutlined key="edit" onClick={onEditClick} />,
              <DeleteFilled key="ellipsis" onClick={onDeleteClick} />,
            ]
          : getRole() === "nurse"
          ? [<EditOutlined key="edit" onClick={onEditClick} />]
          : []
      }
    >
      <div className="mt-3">
        {patientDetails.formatted_patient_name && (
          <p>Name: {patientDetails.formatted_patient_name}</p>
        )}
        {patientDetails.address && <p>Address: {patientDetails.address}</p>}
        {patientDetails.birthdate && (
          <p>Birthdate: {formatDate(patientDetails.birthdate)}</p>
        )}
        {patientDetails.age && (
          <p>
            Age: {patientDetails.age}{" "}
            {/mo?s?/i.test(patientDetails.age) ||
            /^([1-9]|1[0-3])\s*y\/o$/i.test(patientDetails.age)
              ? "(Child)"
              : "(Adult)"}
          </p>
        )}
        {patientDetails.civil_status && (
          <p>
            Civil Status: {capitalizeFirstLetter(patientDetails.civil_status)}
          </p>
        )}
        {patientDetails.sex && (
          <p>Sex: {capitalizeFirstLetter(patientDetails.sex)}</p>
        )}
        {patientDetails.contact_no && (
          <p>Contact No.: {patientDetails.contact_no}</p>
        )}
        {patientDetails.hmo_type && (
          <p>Insurance (HMO): {capitalizeFirstLetter(patientDetails.hmo_type)}</p>
        )}
        {patientDetails.corporate_type && (
          <p>Corporate: {capitalizeFirstLetter(patientDetails.corporate_type)}</p>
        )}

        {(patientDetails.emergency_contact ||
          patientDetails.relation_w_contact ||
          patientDetails.emergency_contact_no) && (
          <p>
            Emergency Contact:{" "}
            {[patientDetails.emergency_contact || null]
              .filter(Boolean)
              .join("")}
            {patientDetails.relation_w_contact
              ? ` (${patientDetails.relation_w_contact})`
              : ""}
            {patientDetails.emergency_contact_no
              ? `  ${patientDetails.emergency_contact_no}`
              : ""}
          </p>
        )}
      </div>
    </Card>
  );
};
export default PatientCard;
